module.exports = __webpack_public_path__ + "img/side seam.b96ffe3b.png";